import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assistenzaclienti',
  templateUrl: './assistenzaclienti.component.html',
  styleUrls: ['./assistenzaclienti.component.scss']
})
export class AssistenzaclientiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/assistenzaclienti/assistenzaclienti.component.ts